import { Link } from 'react-router-dom';
import { useStyle } from '../../../hooks/useStyle';
import './nav-item.css'

export function NavItem(props){
    const item = props.items;
    const styles = useStyle();
    return(
        <>
            {   item !== 'Services' 
                // && item !== 'About us'
                ? <Link className="nav-item_link" to={item.link} style={{backgroundColor : styles[0], color : styles[1]}}>
                    <li className="nav-item" style={{backgroundColor : styles[0], color : styles[1]}}>{item.name}</li >
                  </Link>
                : {item}
            }
        </>
    );
}